/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import CioConditionViewerBase, { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';

interface CioConditionViewerUnknownArgs extends CioConditionViewerBaseArgs {
  condition: any;
}

export default class CioConditionViewerUnknown extends CioConditionViewerBase<CioConditionViewerUnknownArgs> {}
